import { CustomButton } from 'src/components/CustomButton';
import { BOOK_DEMO_ORIGIN } from 'src/data/common';
import { useBusinessBookDemo, useIsCustomerOnBusinessOrEnterprisePlan } from 'src/services';

import { useStyles } from './useStyles';

export const BookDemoButton = () => {
  const styles = useStyles();

  const isCustomerOnBusinessOrEnterprisePlan = useIsCustomerOnBusinessOrEnterprisePlan();

  const { allowedToBookDemo, executeBookDemoFlow } = useBusinessBookDemo(
    BOOK_DEMO_ORIGIN.topNavigation
  );

  if (!allowedToBookDemo || isCustomerOnBusinessOrEnterprisePlan) {
    return null;
  }

  return (
    <CustomButton
      className={styles.root}
      onClick={executeBookDemoFlow}
    >
      Book demo
    </CustomButton>
  );
};
